module.exports = __webpack_public_path__ + "dist/assets/img/bige-icon-search.9d8d1fd7.svg";